import script from "./ConsentItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsentItem.vue?vue&type=script&setup=true&lang=js"

import "./ConsentItem.vue?vue&type=style&index=0&id=6518bd49&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6518bd49"]])

export default __exports__